import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import Slider from "react-slick";
import ShowMoreText from "react-show-more-text";

function TextGrid() {
  let pageHeader = React.createRef();
  const settings = {
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "p-10",
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${require("assets/images/asset2.jpg")})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          overflow: "hidden",
        }}
        className="py-5"
        data-parallax={true}
        ref={pageHeader}
      >
        <Container>
          <Row>
            <Col className="ml-auto mr-auto " md={12}>
              <h1 className="title mb-4 section-title text-white">
                <b>EVENT OVERVIEW</b>
              </h1>
              <br />
            </Col>
            <Col lg={7} className="align-self-center">
              <h3 className="text-400  text-white">
                <ShowMoreText
                  lines={3}
                  more="Read more"
                  less="Read less"
                  className="content-css"
                  anchorClass="text-primary"
                  expanded={false}
                  width={10000}
                >
                  Urbanization is one of the most important social-economic
                  phenomena in today's world. As of now, By 2030, the world will
                  have 43 megacities, each with more than 10 million
                  inhabitants. Combined with the overall growth of the world’s
                  population, the shift to cities will add another 2.5 billion
                  people to urban areas by 2050, increasing the proportion of
                  the population living in urban areas from the current 55% to
                  68%. As more people flock to cities, new mega-cities and city
                  clusters begin to take form.
                  <br />
                  <br />
                  In the GCC, by 2025, the population is predicted to reach 57
                  million, with an additional 14 million people expected to call
                  the region home by 2050. Traditional urban environments are
                  typically not designed to accommodate a growing population,
                  particularly in terms of infrastructure and digital
                  connectivity. That is why the region’s move towards smart city
                  developments is more important than ever before.
                  <br />
                  <br />
                  The core of smart city development is engagement with the
                  residents. The level and quality of engagement include aspects
                  such as interdependence, choice of interaction; feedback on
                  governance; adoption of new technologies and channels; and
                  communicating reviewing existing services. This helps make
                  cities more livable, resilient, and able to better respond to
                  challenges. In the journey toward becoming smarter, the aim is
                  to have cohesion between physical, digital, and human systems.
                  <br />
                  <br />
                  Digitalization is one of the strongest driving forces that
                  power smart cities. Multiple sectors are being disrupted
                  positively by the development and commercial deployment of
                  emerging technologies. The regions’ governments support the
                  new phase through a planned evolution of laws and regulations.
                  Smart infrastructure remains the foundation, enabled by smart
                  payments innovation. The technologies of the Fourth Industrial
                  Revolution (Industry 4.0 or 4IR), which are already being
                  tested commercially, play a vital role in developing smarter
                  cities that fulfill the expectations of their inhabitants.
                  <br />
                  <br />
                  With the rollout of 5G across the GCC and most countries of
                  the world, the vision of “Smart City of the future” becomes a
                  realistic vision. Stakeholders will come together over a
                  packed conference agenda to discuss the future of seamless
                  connectivity, and how it will improve lives and cities. They
                  will analyze the expeditious transformation MENA region has
                  undergone to develop some of the world's leading smart cities.
                  This event will provide a platform to discuss strategies for
                  sustainable urban development.
                  <br />
                  <br />
                  The idea of smart cities in the minds of citizens is an
                  innovative and environment-friendly city of the future, in the
                  form of ‘greener’ government and business practices. From less
                  traffic congestion on roads to connected healthcare systems,
                  smart cities are hoped to revolutionize the way the region
                  functions.
                </ShowMoreText>
                <br />
                <br />
                <Button
                  className="px-3 py-2 rounded-0"
                  color="primary"
                  href="/register"
                >
                  <p className="m-0 text-700" style={{ color: "#010822" }}>
                    REGISTER INTEREST TO ATTEND
                  </p>
                </Button>
              </h3>
            </Col>
            <Col lg={4}></Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={11} className="mt-5">
              <Slider {...settings}>
                {content.map((c) => (
                  <a href={c.link} key={c.link}>
                    <img
                      src={require(`assets/banners/${c.image}`)}
                      width="100%"
                      // style={{ maxWidth: "728px" }}
                      alt=""
                    />
                  </a>
                ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

const content = [];

export default TextGrid;
